import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Slide,
  IconButton,
  Snackbar,
} from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import {
  EmailIcon,
  FacebookIcon,
  LineIcon,
  LinkedinIcon,
  RedditIcon,
  TelegramIcon,
  TwitterIcon,
  FacebookMessengerIcon,
  WhatsappIcon,
  EmailShareButton,
  FacebookShareButton,
  LineShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TelegramShareButton,
  TwitterShareButton,
  FacebookMessengerShareButton,
  WhatsappShareButton,
} from 'react-share'

import useStyles from './styles'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />
}

const ShareDialog = ({ post, openShare, handleCloseShare }) => {
  const classes = useStyles()
  const [copied, setCopied] = useState(false)
  const [open, setOpen] = React.useState(false)

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
  }

  return (
    <Dialog
      className={classes.dialog}
      open={openShare}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleCloseShare}
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogTitle className={classes.title} id='alert-dialog-slide-title'>
        {'Share Your room to your friends'}
      </DialogTitle>
      <DialogContent className={classes.content}>
        <div className={classes.shareButton}>
          <CopyToClipboard
            text={`https://oyeeah.com/posts/${post._id}`}
            onCopy={() => setCopied(true)}
          >
            <IconButton
              aria-label='delete'
              fontSize='small'
              className={classes.copyButton}
              onClick={handleClick}
            >
              <FileCopyIcon />
            </IconButton>
          </CopyToClipboard>
          {copied ? (
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
              <Alert onClose={handleClose} severity='success'>
                Link Copied
              </Alert>
            </Snackbar>
          ) : null}
          <FacebookMessengerShareButton
            url={`https://oyeeah.com/posts/${post._id}`}
            className={classes.socialButton}
          >
            <FacebookMessengerIcon size={45} round />
          </FacebookMessengerShareButton>

          <FacebookShareButton
            url={`https://oyeeah.com/posts/${post._id}`}
            className={classes.socialButton}
          >
            <FacebookIcon size={45} round />
          </FacebookShareButton>

          <TwitterShareButton
            url={`https://oyeeah.com/posts/${post._id}`}
            className={classes.socialButton}
          >
            <TwitterIcon size={45} round />
          </TwitterShareButton>

          <WhatsappShareButton
            url={`https://oyeeah.com/posts/${post._id}`}
            className={classes.socialButton}
          >
            <WhatsappIcon size={45} round />
          </WhatsappShareButton>
        </div>
        <div className={classes.shareButton}>
          <TelegramShareButton
            url={`https://oyeeah.com/posts/${post._id}`}
            className={classes.socialButton}
          >
            <TelegramIcon size={45} round />
          </TelegramShareButton>

          <LinkedinShareButton
            url={`https://oyeeah.com/posts/${post._id}`}
            className={classes.socialButton}
          >
            <LinkedinIcon size={45} round />
          </LinkedinShareButton>

          <EmailShareButton
            url={`https://oyeeah.com/posts/${post._id}`}
            className={classes.socialButton}
          >
            <EmailIcon size={45} round />
          </EmailShareButton>

          <RedditShareButton
            url={`https://oyeeah.com/posts/${post._id}`}
            className={classes.socialButton}
          >
            <RedditIcon size={45} round />
          </RedditShareButton>

          <LineShareButton
            url={`https://oyeeah.com/posts/${post._id}`}
            className={classes.socialButton}
          >
            <LineIcon size={45} round />
          </LineShareButton>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ShareDialog
